import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBF6EC] text-[#20160A] px-6 text-center font-sans">
      <span className="text-7xl font-extrabold text-[#F7C920]">404</span>
      <h1 className="mt-4 text-2xl font-bold">This page couldn't be found</h1>
      <p className="mt-2 text-[#4A3B26] max-w-md">The page you're looking for doesn't exist or may have moved.</p>
      <Link to="/" className="mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#F7C920] text-[#20160A] font-bold hover:bg-[#e8ba0f] transition-colors">
        <Home className="h-4 w-4" /> Back to home
      </Link>
    </div>
  );
}
